<div class="flex justify-center items-center grow h-full mt-12 bg-theme-blue">
  <div class="flex flex-col justify-center text-center w-full md:pl-0 md:pr-0 md:pb-0 md:w-3/4 lg:w-2/3 p-2 md:mt-5 lg:mt-20">

    <div class="flex flex-col text-left pb-2 mb-2 pl-2 pr-2 bg-white rounded-xl" *ngIf="!router.url?.endsWith('thanks')">
      <app-sub-v2-header ></app-sub-v2-header>
    </div>

    <router-outlet />

  </div>
</div>
